<prism-dialog
	id="sh-request-business-dialog-container-div"
	[visible]="true"
	confirm-button=""
	cancel-button=""
	*transloco="let t; read: 'cloud.shure-cloud.request-business-account'"
>
	<span id="sh-request-business-title-h1" slot="dialog-title">
		{{ t('request-business-account') }}
	</span>
	<div id="sh-request-business-confirm-text-div">
		{{ t('request-business-account-content') }}
	</div>
	@if (formGroup) {
		<form [formGroup]="formGroup">
			<div id="sh-request-business-organizationName-container">
				<prism-input
					id="sh-request-business-name-field"
					[placeholder]="t('organization-name')"
					formControlName="organizationName"
					required="true"
					[isValid]="!formGroup.get('organizationName')?.invalid"
				>
					<span slot="label">
						{{ t('organization-name') }}
					</span></prism-input
				>
				@if (formGroup.get('organizationName')?.invalid) {
					<div
						class="sh-request-business-invalid-div"
						id="sh-request-business-organizationName-error-wrapper-div"
					>
						@if (
							formGroup.get('organizationName')?.hasError('required') ||
							formGroup.get('organizationName')?.hasError('whitespace')
						) {
							<span class="prism-caption sh-request-businessr-error-text">
								{{ 'cloud.shared.error-labels.organization-name-required' | transloco }}
							</span>
						} @else if (formGroup.get('organizationName')?.hasError('maxlength')) {
							<span class="prism-caption sh-request-business-error-text">
								{{ 'cloud.shared.error-labels.must-be-max-length' | transloco: { number: 150 } }}
							</span>
						}
					</div>
				}
			</div>
			<div id="sh-request-business-companyName-container">
				<prism-input
					id="sh-request-business-company-name-field"
					[placeholder]="t('company-name')"
					formControlName="companyName"
					required="true"
					[isValid]="!formGroup.get('companyName')?.invalid"
				>
					<span slot="label">
						{{ t('company-name') }}
					</span>
				</prism-input>
				@if (
					formGroup.get('companyName')?.invalid &&
					(formGroup.get('companyName')?.touched || formGroup.get('companyName')?.dirty)
				) {
					<div class="sh-request-business-invalid-div" id="sh-request-business-companyName-error-wrapper-div">
						@if (
							formGroup.get('companyName')?.hasError('required') ||
							formGroup.get('companyName')?.hasError('whitespace')
						) {
							<span class="prism-caption sh-request-businessr-error-text">
								{{ 'cloud.shared.error-labels.company-name-required' | transloco }}
							</span>
						}
					</div>
				}
			</div>
			<div>
				<prism-checkbox
					[formControlName]="'useContactInfo'"
					[checked]="'useContactInfo'"
					id="sh-request-business-use-contact-info-checkbox"
				>
					{{ t('use-contact-information-text') }}
				</prism-checkbox>
			</div>
			<div id="sh-request-business-action-buttons-div" slot="dialog-footer-buttons">
				<prism-button (click)="closeDialog()" id="sh-request-business-button-cancel">
					{{ t('cancel') }}
				</prism-button>
				<prism-button
					[disabled]="formGroup.invalid"
					(click)="submitRequestVerification()"
					id="sh-request-business-send-request-button"
				>
					{{ t('send-request') }}
				</prism-button>
			</div>
		</form>
	}
</prism-dialog>
